import { z } from "zod";
import { AgencyTypeFieldsSchema, AgencyTypeSchema } from "./shared";

/**
 * Minimal packaged service schema for lead form display
 * Used when a packaged service is pre-selected via URL parameter
 */
export const PackagedServiceMinimalSchema = z.object({
    id: z.number(),
    name: z.string(),
    thumbnail: z.string().nullable().optional(),
});

export type PackagedServiceMinimal = z.infer<typeof PackagedServiceMinimalSchema>;

/**
 * Minimal expert schema for lead form display (public endpoint)
 * Returned by GET /api/v2/public/experts/:slug/minimal
 * 
 * Note: Named with "Public" prefix to avoid conflict with ExpertMinimalSchema in leads-v2
 */
export const PublicExpertMinimalSchema = z.object({
    id: z.number(),
    name: z.string(),
    expert_type: z.enum(["freelancer", "agency"]),
    agency_type: AgencyTypeSchema.optional(),
    agency_type_fields: AgencyTypeFieldsSchema.optional(),
    freelancer_role: z.string().nullable().optional(),
    profile_image: z.string().nullable().optional(),
});

export type PublicExpertMinimal = z.infer<typeof PublicExpertMinimalSchema>;

/**
 * Response schema for the minimal expert endpoint
 * GET /api/v2/public/experts/:slug/minimal
 */
export const PublicExpertMinimalResponseSchema = z.object({
    expert: PublicExpertMinimalSchema,
    packaged_service: PackagedServiceMinimalSchema.nullable(),
});

export type PublicExpertMinimalResponse = z.infer<typeof PublicExpertMinimalResponseSchema>;

// Aliases for backward compatibility (export with the original names as well)
export { PublicExpertMinimalSchema as ExpertMinimalPublicSchema };
export type { PublicExpertMinimal as ExpertMinimalPublic };
